import React from "react";
class MapBanffNationalPark extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-banff-national-park" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Banff,+AB,+Canada&daddr=Moraine+Lake,+AB+to:Lake+Louise,+AB+to:Peyto+Lake,+AB+to:Columbia+Icefield,+AB+to:Athabasca+Falls,+AB+to:Jasper,+AB,+Canada&output=embed"
            width="100%"
            height="420"
            title="Banff National Park route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapBanffNationalPark;
